module.exports = __webpack_public_path__ + "static/heroBG-24bc5795e8873f81e68425635eaca0d2.png";